import { StyleSheet } from '@react-pdf/renderer';

import { PDF_STYLES_CONSTANTS } from './constants/pdfStylesConstants.ts';

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: PDF_STYLES_CONSTANTS.POSITIONS.HEADER_TOP,
    width: PDF_STYLES_CONSTANTS.DIMENSIONS.CONTENT_WIDTH,
    flexDirection: 'row',
    left: PDF_STYLES_CONSTANTS.DIMENSIONS.LEFT_MARGIN,
  },
  spaceBetween: {
    flex: PDF_STYLES_CONSTANTS.LAYOUT.FLEX_FULL,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: PDF_STYLES_CONSTANTS.COLORS.SECONDARY_DARK,
  },
  logo: {
    width: PDF_STYLES_CONSTANTS.DIMENSIONS.LOGO_WIDTH,
  },
  leftSectionTitle: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '135px',
  },
  textTruncate: {
    textAlign: 'left',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    width: '135px',
    maxLines: 1,
  },
  textBold: {
    fontWeight: 'bold',
  },
  leftSection: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: PDF_STYLES_CONSTANTS.SPACING.GAP,
  },
});

export default styles;
